import './details';
import './belegungAnlegen';
import './sachkostenblatt';
import { dbh_ajax } from "Ressources/dbh_ajax";

$(document).ready(function () {
   
});
